module.exports = __webpack_public_path__ + "media/images/badge/cervellone_secondary-c8d465e92b0ae1cad0a3f3fae9dc054d.png";